import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Schema } from '../../../../amplify/data/resource';
import Button from '../../../components/custom/Button';
import Tabs from '../../../components/custom/Tabs';
import TextField from '../../../components/custom/TextField';
import { formatIsraeliPhoneNumber } from '../../../utils/format/format';
import Feezback from './Feezback';
import OXS from './OXS';
import Integrated from './Integrated';

const CustomPayment: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Typography
          fontSize="30px"
          fontWeight="700"
          fontFamily={'AlmoniDL'}
          textAlign={'right'}
          sx={{ whiteSpace: 'nowrap' }}
        >
          תשלום
        </Typography>
      </Box>
      <Divider
        sx={{
          width: '100%',
          height: '1px',
          backgroundColor: theme.palette.dark.border,
        }}
      />

      <Stack direction="row-reverse" justifyContent="space-between" spacing={2}>
        <Feezback />
        <Divider 
          orientation="vertical" 
          flexItem 
          sx={{
            backgroundColor: theme.palette.dark.border,
          }}
        />
        <Integrated />
        <Divider 
          orientation="vertical" 
          flexItem 
          sx={{
            backgroundColor: theme.palette.dark.border,
          }}
        />
        <OXS />
      </Stack>
    </Box>
  );
};

export default CustomPayment;
